import { render } from "./BaseException.vue?vue&type=template&id=7d6c62ce&bindings={\"title\":\"props\",\"component\":\"props\"}"
import script from "./BaseException.vue?vue&type=script&lang=ts"
export * from "./BaseException.vue?vue&type=script&lang=ts"
script.render = render

export default script